import { from, Observable, of } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { RootState } from '../../store/state';
import { CreateErrorNotice, CreateSuccessNotice } from '../../store/actions/toaster.action';
import {
  OrganizationAction,
  OrganizationActions,
  UpdateOrgConfig,
  UpdateOrgConfigError,
  UpdateOrgConfigSuccess,
} from '../actions/organization';
import OrganizationService from '../../shared/services/organization.service';
import { LoadUserProfileInfo } from '../../profile/actions/profile.action';

const updateConfigEpic = (action$: Observable<OrganizationAction>, state$: StateObservable<RootState>) => action$.pipe(
  ofType<UpdateOrgConfig>(OrganizationActions.UpdateOrgConfig),
  switchMap(({ updates }) => from(OrganizationService.updateConfig(
    state$.value.orgHierarchy.selectedOrg._id,
    state$.value.orgHierarchy.selectedOrg.config,
    updates,
  )).pipe(
    mergeMap(() => of(
      new UpdateOrgConfigSuccess(),
      new LoadUserProfileInfo(),
      new CreateSuccessNotice('Success', 'Configuration was updated successfully!'),
    )),
    catchError(error => of(
      new UpdateOrgConfigError(error.message),
      new CreateErrorNotice('Error', 'Failed to update configuration.'),
    )),
  )),
);

const OrganizationEpics = [
  updateConfigEpic,
];

export default OrganizationEpics
